import { getOS, getUserAgent, getVersion } from './utils'

type DeviceSystemInfo = {
  os: string
  version: string | null
}

export function getDeviceSystemInfo(): DeviceSystemInfo {
  // data
  const userAgent = getUserAgent()
  const os = getOS(userAgent)
  const version = getVersion(userAgent, os)

  return {
    os,
    version,
  }
}
